import messageUtils from "@utils/messageUtils";
import axios from "axios";

import Jsona from "jsona";

const dataFormatter = new Jsona();

const getDefaultState = () => ({
  soilSensor: null,
  shouldFetchSoilSensors: false,
});

export const state = getDefaultState();

export const actions = {
  async getSoilSensors({ commit }, payload) {
    try {
      const response = await axios.get(`/v1/soil_sensors${payload}`);
      return {
        data: dataFormatter.deserialize(response.data),
        headers: response.headers,
      };
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },

  async addSoilSensor({ commit }, payload) {
    try {
      return axios.post(`/v1/sensor_transmitters/${payload.id}/add_sensor`);
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },

  async updateSoilSensor({ commit }, payload) {
    try {
      return axios.patch(`/v1/soil_sensors/${payload.id}`, { ...payload });
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },

  async deleteSoilSensor({ commit }, payload) {
    try {
      await axios.delete(`/v1/soil_sensors/${payload.computedQueriesUrl}`, {
        data: { password_confirmation: payload.password_confirmation },
      });
      messageUtils.showSuccess(i18n.t("fields.requests.delete"));
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },
};

export const mutations = {
  setSoilSensor(state, soilSensor) {
    state.soilSensor = soilSensor;
  },

  setShouldFetchSoilSensors(state, value) {
    state.shouldFetchSoilSensors = value;
  },

  RESET_MODULE(state) {
    Object.assign(state, getDefaultState());
  }
};


// import messageUtils from "@utils/messageUtils";
// import axios from "axios";

// import Jsona from "jsona";

// const dataFormatter = new Jsona();

// export const state = {
//   soilSensor: null,
//   shouldFetchSoilSensors: false,
// };

// export const actions = {
//   async getSoilSensors({ commit }, payload) {
//     try {
//       const response = await axios.get(`/v1/soil_sensors${payload}`);
//       return {
//         data: dataFormatter.deserialize(response.data),
//         headers: response.headers,
//       };
//     } catch (error) {
//       messageUtils.showErrors(error);
//       return Promise.reject(error);
//     }
//   },

//   async addSoilSensor({ commit }, payload) {
//     try {
//       return axios.post(`/v1/sensor_transmitters/${payload.id}/add_sensor`);
//     } catch (error) {
//       messageUtils.showErrors(error);
//       return Promise.reject(error);
//     }
//   },

//   async updateSoilSensor({ commit }, payload) {
//     try {
//       return axios.patch(`/v1/soil_sensors/${payload.id}`, { ...payload });
//     } catch (error) {
//       messageUtils.showErrors(error);
//       return Promise.reject(error);
//     }
//   },

//   async deleteSoilSensor({ commit }, payload) {
//     try {
//       await axios.delete(`/v1/soil_sensors/${payload.computedQueriesUrl}`, {
//         data: { password_confirmation: payload.password_confirmation },
//       });
//       messageUtils.showSuccess(i18n.t("fields.requests.delete"));
//     } catch (error) {
//       messageUtils.showErrors(error);
//       return Promise.reject(error);
//     }
//   },
// };

// export const mutations = {
//   setSoilSensor(state, soilSensor) {
//     state.soilSensor = soilSensor;
//   },

//   setShouldFetchSoilSensors(state, value) {
//     state.shouldFetchSoilSensors = value;
//   },
// };
